import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable} from 'rxjs';

export interface IDisclosureResult {
  signed: boolean;
  created: boolean;
  idv_completed: boolean;
  disclosure?: ICreateDisclosureResponse;
}

export interface IRecipient {
  name: string;
  email: string;
  signing_order: number;
  signing_url: string;
  id: number;
  token: string;
  recipient_id: number;
  role: string;
}

export interface ICreateDisclosureResponse {
  document_id: string;
  recipient: IRecipient;
  signing_url: string;
}

@Injectable({
  providedIn: 'root',
})
export class DisclosuresService {
  public requestHeader = {};
  
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  public checkDisclosuresSigned(code: string, role?: string): Observable<IDisclosureResult> {
    const params = role ? { role } : {};
    return this.http.get<IDisclosureResult>(`${this.baseUrl}v1/disclosures/check-if-signed-for-background-check/${code}`, { params });
  }
  
  public createDisclosuresDocument(name: string, code: string, ssn: string, role: string): Observable<ICreateDisclosureResponse> {
    return this.http.post<ICreateDisclosureResponse>(`${this.baseUrl}v1/disclosures/create-for-background-check`, { name, code, ssn, role });
  }

  public markIdvCompleted(code: string, role?: string): Observable<void> {
    const params = role ? { role } : {};
    return this.http.post<void>(`${this.baseUrl}v1/disclosures/mark-idv-completed/${code}`, {}, { params });
  }
}
